import React, { useEffect, useState } from "react";
import api from 'api';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from "common/config-api";

const ProductInventory = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [productList, setProductList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBlock, setSelectedBlock] = useState('');

  const getProductList = async () => {
    try {
      const response = await api.get(API.PRODUCT_INVENTORY);
      setProductList(response.data || []);
    } catch (error) {
      console.error('상품 목록을 불러오는 중 오류가 발생했습니다:', error);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleBlockChange = (event) => {
    setSelectedBlock(event.target.value);
  };

  const filteredProducts = productList.filter(product => {
    const matchesSearch = product.productName?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesBlock = !selectedBlock || product.productInventoryBlock === selectedBlock;
    return matchesSearch && matchesBlock;
  });

  useEffect(() => {
    getProductList();
  }, []);

  const blockOptions = Array.from({ length: 26 }, (_, i) => 
    String.fromCharCode(65 + i)
  ).map(block => (
    <option key={block} value={block}>BLOCK {block}</option>
  ));

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">상품 재고 관리</h5>

          <div className="row mb-3">
            <div className="col-sm-4">
              <input 
                type="text" 
                onChange={handleSearch}
                className="form-control" 
                placeholder="상품명 검색" 
              />
            </div>

            <div className="col-sm-2">
              <select 
                className="form-select" 
                onChange={handleBlockChange}
                value={selectedBlock}
              >
                <option value="">전체 블록</option>
                {blockOptions}
              </select>
            </div>
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">블록</th>
                <th scope="col">행</th>
                <th scope="col">상품명</th>
                <th scope="col">가격</th>
                <th scope="col">재고</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.map((product, index) => (
                <tr key={index}>
                  <td>{product.productInventoryBlock}</td>
                  <td>{product.productInventoryRow}</td>
                  <td>{product.productName}</td>
                  <td>￥{product.productPrice?.toLocaleString()}</td>
                  <td>{product.productInventoryCnt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductInventory;


